import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { CompanyLogo } from "app/pages/sales-intelligence/common-components/CompanyLogo/CompanyLogo";
import useCurrentStateAndParamsWithFixedDomain from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCurrentStateAndParamsWithFixedDomain";
import CRMIntegration from "app/pages/sales-intelligence/pages/company-analysis/components/cards/company-card/CRMIntegration/CRMIntegration";

const CompanyCardEmpty = () => {
    const { params } = useCurrentStateAndParamsWithFixedDomain();
    return (
        <Flex
            flexDirection="column"
            justifyContent="space-between"
            flexGrow="1"
            padding="24px"
            gap="16px"
            minHeight="112px"
        >
            <Flex
                alignItems="center"
                gap="16px"
            >
                <Flex
                    alignItems="center"
                    gap="8px"
                >
                    <CompanyLogo isEmpty />
                    <Text
                        fontVariant="h5"
                        color={colorsPalettes.carbon[500]}
                        data-automation="company-name"
                    >
                        {params.key}
                    </Text>
                </Flex>
                <CRMIntegration companyInfo={undefined} />
            </Flex>
            <Text
                fontVariant="input2"
                color={colorsPalettes.carbon[300]}
                data-automation="empty-company-card-title"
            >
                {translate("si.account-overview.company-card.empty.text")}
            </Text>
        </Flex>
    );
};

export default CompanyCardEmpty;
